import sortBy from 'lodash/sortBy';
import type {LinkEntityType} from 'types';
import {Concept} from 'types';
import type {VerifiedLinkedLiterary} from 'schemaDefinition/types';
import {isLinkedAgentLink} from 'schemaDefinition/functions/isLinkedAgentLink';
import type {LinkRole} from 'schemaDefinition/types/linkTypes';
import {formatNameVariantValue} from 'schema/preview/functions/formatNameVariantValue';
import {splitRoleEntityCode} from './splitEntityRoleEntityCode';

const targetTypeOrder: {[key in LinkEntityType]: number} = {
  [Concept.series]: 1,
  [Concept.educationalSeries]: 2,
  [Concept.otherConnection]: 3,
  [Concept.publisherSeries]: 1,
  [Concept.work]: 4,
  [Concept.expression]: 5,
  [Concept.manifestation]: 6,
  [Concept.agent]: 7,
  [Concept.person]: 8,
  [Concept.corporation]: 9,
  [Concept.event]: 10,
  [Concept.publisher]: 11,
  [Concept.prize]: 12,
};

const linkRoleOrder: {[key in LinkRole]: number} = {
  partOf: 1,
  contains: 2,
  basedOn: 3,
  hasInspired: 4,
  mentions: 5,
  mentionedIn: 6,
  relatedTo: 7,
  hasPseudonym: 8,
  pseudonymFor: 9,
  awarded: 10,
  awardedTo: 11,
  awardedFor: 12,
};

export const sortLinks = (
  links: VerifiedLinkedLiterary[] | undefined,
): VerifiedLinkedLiterary[] | undefined => {
  if (!links) {
    return links;
  }

  const extendedLinks = links.map(link => ({
    link,
    value: isLinkedAgentLink(link.link)
      ? formatNameVariantValue(link.link.agentName, link.link.type)
      : link.link.name,
    codeParts: splitRoleEntityCode(link.role),
  }));

  const sortedExtendedLinks = sortBy(
    extendedLinks,
    el => targetTypeOrder[el.codeParts.target],
    el => linkRoleOrder[el.codeParts.role],
    el => el.value,
  );

  return sortedExtendedLinks.map(el => el.link);
};
